import $x from '@/utils/$x';

export async function submitMemberPlanAnalysis(params) {
  return $x.post('/memberTrainingWorkspace/currentPlan/analysis/submit', params, { timeout: 60000 });
}

export async function queryMemberPlanAnalysis(params) {
  return $x.post('/memberTrainingWorkspace/currentPlan/analysis/query', params, { timeout: 10000 });
}

export async function getMemberTagReview(params) {
  return $x.post('/memberTrainingWorkspace/tags/review/query', params, { timeout: 10000 });
}

export async function saveMemberTagReview(params) {
  return $x.post('/memberTrainingWorkspace/tags/review/save', params, { timeout: 10000 });
}

export async function retryMemberCommunicationWindow(params) {
  return $x.post('/memberTrainingWorkspace/processing/communication/retry', params, {
    timeout: 10000,
  });
}

export async function retryMemberCourseEvaluation(params) {
  return $x.post('/memberTrainingWorkspace/processing/course/retry', params, {
    timeout: 10000,
  });
}

export async function retryMemberFactSync(params) {
  return $x.post('/memberTrainingWorkspace/processing/fact/retry', params, {
    timeout: 10000,
  });
}

export async function getMemberCourseProcessing(params) {
  return $x.post('/memberTrainingWorkspace/processing/course', params, {
    timeout: 10000,
  });
}

export async function getMemberCommunicationProcessing(params) {
  return $x.post('/memberTrainingWorkspace/processing/communication', params, { timeout: 10000 });
}

/** 档案菜单授权后分页读取动态标签；该查询不触发大模型。 */
export async function getMemberCommunicationTags(params) {
  return $x.post('/memberTrainingWorkspace/tags/page', params, { timeout: 10000 });
}

/** 单标签按需读取引用证据，不加载整份问卷。 */
export async function getMemberTagEvidence(params) {
  return $x.post('/memberTrainingWorkspace/tags/evidence', params, { timeout: 10000 });
}

export async function getMemberCurrentPlan(params) {
  return $x.post('/memberTrainingWorkspace/currentPlan/overview', params, { timeout: 10000 });
}

export async function getMemberCurrentPlanSchedule(params) {
  return $x.post('/memberTrainingWorkspace/currentPlan/schedule', params, { timeout: 20000 });
}

export async function getMemberCurrentPlanTiming(params) {
  return $x.post('/memberTrainingWorkspace/currentPlan/timing', params, { timeout: 15000 });
}

export async function getMemberCurrentPlanHistory(params) {
  return $x.post('/memberTrainingWorkspace/currentPlan/history', params, { timeout: 10000 });
}

export async function getMemberCurrentPlanCourse(params) {
  return $x.post('/memberTrainingWorkspace/currentPlan/course', params, { timeout: 20000 });
}

/**
+ * 获取RTC信令消息定义列表
+ * @param {*} params
+ * @returns
+ */
export async function getSignallingDefinitions(params) {
  return $x.get(`/technical/rtc/signalling/definitions`, params);
}

/**
+ * 获取指定房间RTC信令消息
+ * @param {*} params
+ * @returns
+ */
export async function getSignallingInfo(params) {
  return $x.get(`/technical/rtc/signalling/room`, params);
}

/**
+ * 获取指定房间RTC信令消息
+ * @param {*} params
+ * @returns
+ */
export async function getSignallingQuality(params) {
  return $x.get(`/technical/rtc/quality`, params);
}

/**
+ * 获取指定房间RTC事件详情
+ * @param {*} params
+ * @returns
+ */
export async function getEventDetail(params) {
  return $x.get(`/technical/rtc/event/detail`, params);
}

/**
+ * 获取指定房间RTC异常事件
+ * @param {*} params
+ * @returns
+ */
export async function getEventAbnormal(params) {
  return $x.get(`/technical/rtc/event/abnormal`, params);
}
/**
+ * 分页查询人工降级配置数据列表
+ * @param {*} params
+ * @returns
+ */
export async function getDowngradeConfigList(params) {
  return $x.post(`/downgradeManage/getDowngradeConfigList`, params);
}
/**
+ * 管理  人工降级配置数据
+ * @param {*} params
+ * @returns
+ */
export async function manageDowngradeConfigStatus(params) {
  return $x.post(`/downgradeManage/manageDowngradeConfigStatus`, params);
}
/**
+ * 保存 人工降级配置数据
+ * @param {*} params
+ * @returns
+ */
export async function saveDowngradeConfig(params) {
  return $x.post(`/downgradeManage/saveDowngradeConfig`, params);
}

/** 查询 Power Move 动作分析全局开关。 */
export async function getPowerMoveGlobalSwitch(params) {
  return $x.post('/powerMoveWhitelistManage/getGlobalSwitch', params);
}

/** 更新 Power Move 动作分析全局开关。 */
export async function updatePowerMoveGlobalSwitch(params) {
  return $x.post('/powerMoveWhitelistManage/updateGlobalSwitch', params);
}

/** 分页查询 Power Move 动作分析白名单。 */
export async function getPowerMoveWhitelistPage(params) {
  return $x.post('/powerMoveWhitelistManage/pageWhitelist', params);
}

/** 新增或编辑 Power Move 动作分析白名单。 */
export async function savePowerMoveWhitelist(params) {
  return $x.post('/powerMoveWhitelistManage/saveWhitelist', params);
}

/** 启用或停用一条 Power Move 动作分析白名单。 */
export async function updatePowerMoveWhitelistStatus(params) {
  return $x.post('/powerMoveWhitelistManage/updateWhitelistStatus', params);
}

/** 分页查询设备型号最新性能。 */
export async function getDeviceModelPerformancePage(params) {
  return $x.post('/downgradeManage/devicePerformanceManage/modelPage', params);
}

/** 分页查询日期范围内用户使用过的设备型号。 */
export async function getDevicePerformanceUsagePage(params) {
  return $x.post('/downgradeManage/devicePerformanceManage/usagePage', params);
}

/** 查询设备性能统计摘要。 */
export async function getDevicePerformanceStats(params) {
  return $x.post('/downgradeManage/devicePerformanceManage/stats', params);
}

/** 查询 Xplan VK 总开关。 */
export async function getXplanVkGlobalSwitch(params) {
  return $x.post('/downgradeManage/xplanVkManage/getGlobalSwitch', params);
}

/** 更新 Xplan VK 总开关。 */
export async function updateXplanVkGlobalSwitch(params) {
  return $x.post('/downgradeManage/xplanVkManage/updateGlobalSwitch', params);
}

/** 分页查询 Xplan VK 黑名单。 */
export async function getXplanVkBlacklistPage(params) {
  return $x.post('/downgradeManage/xplanVkManage/pageBlacklist', params);
}

/** 新增或编辑 Xplan VK 黑名单。 */
export async function saveXplanVkBlacklist(params) {
  return $x.post('/downgradeManage/xplanVkManage/saveBlacklist', params);
}

/** 启用或停用 Xplan VK 黑名单。 */
export async function updateXplanVkBlacklistStatus(params) {
  return $x.post(
    '/downgradeManage/xplanVkManage/updateBlacklistStatus',
    params,
  );
}

/** 分页查询 Power Move 动作分析产生的客观观察。 */
export async function getPowerMoveEvaluationPage(params) {
  return $x.post('/powerMoveEvaluationManage/page', params);
}

/** 查询一次 Power Move 动作的客观观察详情。 */
export async function getPowerMoveEvaluationDetail(params) {
  return $x.post('/powerMoveEvaluationManage/detail', params);
}

/** 分页查询 Power Move 课程客观观察快照。 */
export async function getPowerMoveCourseEvaluationPage(params) {
  return $x.post('/powerMoveEvaluationManage/course/page', params);
}

/** 查询一份 Power Move 课程客观观察快照详情。 */
export async function getPowerMoveCourseEvaluationDetail(params) {
  return $x.post('/powerMoveEvaluationManage/course/detail', params);
}

/** 查询会员当前十维 Power Move 能力账户快照。 */
export async function getPowerMoveCapabilityAccountCurrent(params) {
  return $x.post('/powerMoveEvaluationManage/account/current', params);
}

/** 查询会员单维 Power Move 能力账户历史快照。 */
export async function getPowerMoveCapabilityAccountHistory(params) {
  return $x.post('/powerMoveEvaluationManage/account/history', params);
}

/** 查询会员训练工作台首屏（档案、训练统计与十维能力账户）。 */
export async function getMemberTrainingWorkspaceSnapshot(params) {
  return $x.post('/memberTrainingWorkspace/snapshot', params);
}

/** 分页查询最近发生变化的会员训练档案。 */
export async function getMemberTrainingWorkspaceMemberPage(params) {
  return $x.post('/memberTrainingWorkspace/member/page', params);
}

/** 将当前会员目标与健康档案冻结为标准化证据，不生成或发布训练计划。 */
export async function syncMemberTrainingWorkspaceProfileEvidence(params) {
  return $x.post('/memberTrainingWorkspace/evidence/sync/profile', params);
}

/** 显式同步近期证据并生成新的当前训练判断快照。 */
export async function refreshMemberTrainingWorkspaceRecommendation(params) {
  return $x.post('/memberTrainingWorkspace/recommendation/refresh', params);
}

/** 查询会员历史不可变训练判断与建议快照。 */
export async function getMemberTrainingWorkspaceRecommendationHistory(params) {
  return $x.post('/memberTrainingWorkspace/recommendation/history', params);
}

/** 从不可变判断快照查询会员训练问题生命周期。 */
export async function getMemberTrainingWorkspaceProblemLifecycles(params) {
  return $x.post('/memberTrainingWorkspace/problem/lifecycles', params);
}

/** 查询当前判断的复评时间、复核项和新增候选证据。 */
export async function getMemberTrainingWorkspaceReassessment(params) {
  return $x.post('/memberTrainingWorkspace/reassessment/workspace', params);
}

/** 对比最近两份不可变训练判断快照。 */
export async function getMemberTrainingWorkspaceReassessmentComparison(params) {
  return $x.post('/memberTrainingWorkspace/reassessment/comparison', params);
}

/** 查询会员级重要训练证据与判断大事记。 */
export async function getMemberTrainingWorkspaceTimeline(params) {
  return $x.post('/memberTrainingWorkspace/timeline', params);
}

export async function getMemberTrainingWorkspaceCurrentCase(params) {
  return $x.post('/memberTrainingWorkspace/case/current', params);
}

export async function getMemberTrainingWorkspaceCaseHistory(params) {
  return $x.post('/memberTrainingWorkspace/case/history', params);
}

export async function getMemberTrainingWorkspaceCaseDetail(params) {
  return $x.post('/memberTrainingWorkspace/case/detail', params);
}

/** 查询所选训练案例由系统形成的不可变生命周期决策历史。 */
export async function getMemberTrainingWorkspaceCaseLifecycleHistory(params) {
  return $x.post('/memberTrainingWorkspace/case/lifecycle/history', params);
}

/** 使用稳定游标分页查询会员标准化训练证据。 */
export async function getMemberTrainingWorkspaceEvidencePage(params) {
  return $x.post('/memberTrainingWorkspace/evidence/page', params);
}

/** 按会员和证据 ID 查询单条不可变训练证据。 */
export async function getMemberTrainingWorkspaceEvidenceDetail(params) {
  return $x.post('/memberTrainingWorkspace/evidence/detail', params);
}

/** 查询训练证据对应的 Ptainer 课房事实。 */
export async function getMemberTrainingWorkspaceClassroomSource(params) {
  return $x.post('/memberTrainingWorkspace/evidence/source/classroom', params);
}

/** 查询会员单维能力账户的不可变历史快照。 */
export async function getMemberTrainingWorkspaceCapabilityHistory(params) {
  return $x.post('/memberTrainingWorkspace/capability/history', params);
}

/** 查询会员近月课程与自定义运动累计。 */
export async function getMemberTrainingWorkspaceProgressMonths(params) {
  return $x.post('/memberTrainingWorkspace/progress/months', params);
}

/** 查询同动作、同 Observation 版本下的原始数值指标历史。 */
export async function getMemberTrainingWorkspaceActionMetricTrend(params) {
  return $x.post('/memberTrainingWorkspace/progress/action-metrics', params);
}

/** 查询会员整个训练生命周期内按动作聚合的训练与评估摘要。 */
export async function getMemberTrainingWorkspaceActionProfiles(params) {
  return $x.post('/memberTrainingWorkspace/action/profiles', params);
}

/** 分页查询会员的动作客观观察。 */
export async function getMemberTrainingWorkspaceActionPage(params) {
  return $x.post('/memberTrainingWorkspace/action/page', params);
}

/** 查询单次动作客观观察的结构化详情。 */
export async function getMemberTrainingWorkspaceActionDetail(params) {
  return $x.post('/memberTrainingWorkspace/action/detail', params);
}

/** 分页查询会员的课程客观观察。 */
export async function getMemberTrainingWorkspaceCoursePage(params) {
  return $x.post('/memberTrainingWorkspace/course/page', params);
}

/** 查询单份课程客观观察快照的结构化详情。 */
export async function getMemberTrainingWorkspaceCourseDetail(params) {
  return $x.post('/memberTrainingWorkspace/course/detail', params);
}

/** 游标查询会员真实发生的课程记录，列表不以“已经生成课程评估”为前提。 */
export async function getMemberTrainingWorkspaceCourseRecords(params) {
  return $x.post('/memberTrainingWorkspace/course/records', params);
}

/** 查询会员训练档案自己的课程详情，并附带该课最新课程评估（若已生成）。 */
export async function getMemberTrainingWorkspaceCourseWorkspaceDetail(params) {
  return $x.post('/memberTrainingWorkspace/course/workspace-detail', params);
}

/**
+ * 获取用户基本信息
+ * @param {*} params
+ * @returns
+ */
export async function getUserInfo(params) {
  return $x.post(`/gpt/get/user/info`, params);
}

/**
+ * 获取用户基本信息
+ * @param {*} params
+ * @returns
+ */
export async function getClassList(params) {
  return $x.post(`/gpt/get/user/class`, params);
}
/**
+ * 获取用户基本信息
+ * @param {*} params
+ * @returns
+ */
export async function getClassInfo(params) {
  return $x.post(`/gpt/get/user/class/info`, params);
}
/**
+ * 获取用户基本信息
+ * @param {*} params
+ * @returns
+ */
export async function getGptText(params) {
  return $x.post(`/gpt/get/text`, params);
}

/**
+ * model
+ * @param {*} params
+ * @returns
+ */
export async function getGptModels(params) {
  return $x.post(`/gpt/get/models`, params);
}
/**
+ * 获取用户基本信息
+ * @param {*} params
+ * @returns
+ */
export async function addRoleMessage(params) {
  return $x.post(`/gpt/role/add`, params);
}
/**
+ * 获取用户基本信息
+ * @param {*} params
+ * @returns
+ */
export async function delRoleMessage(params) {
  return $x.post(`/gpt/role/del`, params);
}
/**
+ * 获取用户基本信息
+ * @param {*} params
+ * @returns
+ */
export async function getRoleMessage(params) {
  return $x.post(`/gpt/role/list`, params);
}

/**
+ * 版本控制--列表
+ * @param {*} params
+ * @returns
+ */
export async function getUniPkgList(params) {
  return $x.post(`/pkg/list`, params);
}
/**
+ * 版本控制--新增
+ * @param {*} params
+ * @returns
+ */
export async function addUniPkg(params) {
  return $x.post(`/pkg/add`, params);
}
/**
+ * 版本控制--更新
+ * @param {*} params
+ * @returns
+ */
export async function modifyUniPkg(params) {
  return $x.post(`/pkg/modify`, params);
}

/**
+ * 版本控制--删除
+ * @param {*} params
+ * @returns
+ */
export async function deleteUniPkg(params) {
  return $x.post(`/pkg/del`, params);
}

/**
 * H5版本管理（ChatBox UI 热更新）--列表
 * @param {*} params
 * @returns
 */
export async function getH5PkgList(params) {
  return $x.post(`/h5/pkg/list`, params);
}

/**
 * H5版本管理--下发模拟查询
 *
 * 与客户端 latest 走**同一条后端代码路径**（后端 H5PkgController#latest 与客户端出口
 * H5PkgApiImpl#latest 都直接调 h5PkgService.latest），所以查出来的就是客户端真实会拿到的结果。
 * 注意：data 为空**不是错误**，表示没有适用于这个 App 版本的包（客户端保持内置包）。
 * @param {*} params
 * @returns
 */
export async function getH5PkgLatest(params) {
  return $x.post(`/h5/pkg/latest`, params);
}

/**
 * H5版本管理--新增（手工登记已上传的产物地址）
 * @param {*} params
 * @returns
 */
export async function addH5Pkg(params) {
  return $x.post(`/h5/pkg/add`, params);
}

/**
 * H5版本管理--编辑（可改最低 App 版本 / 状态）
 * @param {*} params
 * @returns
 */
export async function modifyH5Pkg(params) {
  return $x.post(`/h5/pkg/modify`, params);
}

/**
 * H5版本管理--删除
 * @param {*} params
 * @returns
 */
export async function deleteH5Pkg(params) {
  return $x.post(`/h5/pkg/del`, params);
}

/**
 * H5版本管理--启用/停用（H5 唯一的回滚手段）
 * @param {*} params
 * @returns
 */
export async function onlineOrOffH5Pkg(params) {
  return $x.post(`/h5/pkg/onlineOrOff`, params);
}

/**
 * H5版本管理--上传产物（multipart，后端存 COS + 算 MD5 + 建记录一步到位）
 *
 * 直接传 FormData 即可，**不要**手动设 `Content-Type`：
 * axios 0.23 的 xhr 适配器在 data 是 FormData 时会主动删掉该头
 * （`node_modules/axios/lib/adapters/xhr.js` 的 `delete requestHeaders['Content-Type']`），
 * 让浏览器自己补 boundary；手动设成 `multipart/form-data` 反而会缺 boundary 导致后端解析失败。
 *
 * @param {*} formData
 * @returns
 */
export async function uploadH5Pkg(formData) {
  return $x.post(`/h5/pkg/upload`, formData);
}

// 获取审核列表
export async function getAuditList(params) {
  return $x.post('/v1/litta/pkg/auditing/list', params);
}

// 获取审核列表
export async function addOrUpdateAudit(params) {
  return $x.post('/v1/litta/pkg/auditing/addOrUpdate', params);
}
// 2.1.1 查询安卓渠道配置接口
export async function getAndroidChannel(params) {
  return $x.post('/v1/litta/pkg/auditing/getAndroidChannel', params);
}

// 创建文件夹 ID：nzDJVDl8
export async function createDir(params) {
  return $x.post('/cos/create/dir', params);
}
// 列表查询 ID：q2R7wyn8
export async function getFileList(params) {
  return $x.post('/cos/list', params);
}
// 删除文件夹 ID：K8M79lPz
export async function deleteDir(params) {
  return $x.post('/cos/del/dir', params);
}
// 删除文件
export async function deleteFile(params) {
  return $x.post('/cos/del/file', params);
}

// 预览文件
export async function getFileDetail(params) {
  return $x.post('/cos/get/file', params);
}

// APP版本管理-查询下拉选项
export async function getAppVersionOption(params) {
  return $x.post(`/v1/app/upgrade/option`, params);
}

// APP版本管理-列表
export async function getAppVersionList(params) {
  return $x.post(`/v1/app/upgrade/list`, params);
}

// APP版本管理-保存
export async function saveAppVersion(params) {
  return $x.post(`/v1/app/upgrade/save`, params);
}

// APP版本管理-上下架
export async function appVersionUp(params) {
  return $x.post(`/v1/app/upgrade/onlineOrOff`, params);
}

// 分页查询路由
export async function routerList(params) {
  return $x.post(`/route/manage/list`, params);
}
// 分页查询路由
export async function routerSaveOrUpdate(params) {
  return $x.post(`/route/manage/saveOrUpdate`, params);
}
// 分页查询路由
export async function routerDelete(params) {
  return $x.post(`/route/manage/del`, params);
}
// 分页查询路由
export async function getFoodList(params) {
  return $x.post(`/food/getFoodList`, params);
}
// 分页查询路由
export async function getDishesList(params) {
  return $x.post(`/food/getDishesList`, params);
}

// 更新食品信息
export async function updateFood(params) {
  return $x.post(`/food/updateFood`, params);
}

// 更新菜肴信息
export async function updateDish(params) {
  return $x.post(`/food/updateDishes`, params);
}

// 新增食品信息
export async function addFood(params) {
  return $x.post(`/food/addFood`, params);
}

// 新增菜肴信息
export async function addDishes(params) {
  return $x.post(`/food/addDishes`, params);
}

// 获取大模型菜肴数据
export async function getDishesData(params) {
  return $x.post(`/food/getDishesData`, params);
}

/**
 * 获取卡片模板列表
 * @param {*} params
 * @returns
 */
export async function cardTemplateList(params) {
  return $x.post(`/custom/message/list`, params);
}

/**
 * 获取卡片模板详情
 * @param {*} params
 * @returns
 */
export async function cardTemplateDetail(params) {
  return $x.post(`/custom/message/detail`, params);
}
/**
 * 保存或更新卡片模板
 * @param {*} params
 * @returns
 */
export async function cardTemplateSaveOrUpdate(params) {
  return $x.post(`/custom/message/saveOrUpdate`, params);
}

/**
 * 删除卡片模板
 * @param {*} params
 * @returns
 */
export async function cardTemplateDelete(params) {
  return $x.post(`/custom/message/del`, params);
}
/**
 * 发送卡片模板
 * @param {*} params
 * @returns
 */
export async function cardTemplateSend(params) {
  return $x.post(`/custom/message/send`, params);
}

/**
 * 获取HTML模板列表
 * @param {*} params
 * @returns
 */
export async function htmlTemplateList(params) {
  return $x.post(`/html/template/list`, params);
}

/**
 * 获取HTML模板详情
 * @param {*} params
 * @returns
 */
export async function htmlTemplateDetail(params) {
  return $x.post(`/html/template/detail`, params);
}

/**
 * 删除HTML模板
 * @param {*} params
 * @returns
 */
export async function htmlTemplateDelete(params) {
  return $x.post(`/html/template/del`, params);
}

/**
 * 保存或更新HTML模板
 * @param {*} params
 * @returns
 */
export async function htmlTemplateSaveOrUpdate(params) {
  return $x.post(`/html/template/saveOrUpdate`, params);
}

/**
 * 获取业务HTML模板详情
 * @param {*} params
 * @returns
 */
export async function htmlTemplateBusinessDetail(params) {
  return $x.post(`/html/template/detail`, params);
}
/**
 * 上下架业务HTML模板
 * @param {*} params
 * @returns
 */
export async function htmlTemplateUpDown(params) {
  return $x.post(`/html/template/setUpAndDown`, params);
}

/**
 * 保存或更新业务HTML模板
 * @param {*} params
 * @returns
 */
export async function htmlTemplateBusinessSaveOrUpdate(params) {
  return $x.post(`/html/template/business/saveOrUpdate`, params);
}

/**
 * 删除业务HTML模板
 * @param {*} params
 * @returns
 */
export async function htmlTemplateBusinessDelete(params) {
  return $x.post(`/html/template/business/del`, params);
}
/**
 * 上下架业务HTML模板
 * @param {*} params
 * @returns
 */
export async function htmlTemplateBusinessUpDown(params) {
  return $x.post(`/html/template/business/setUpAndDown`, params);
}

/**
 * 课堂回放-获取教室总结
 * @param {*} params
 * @returns
 */
export async function getClassRoomSummary(params) {
  return $x.post(`/ptrainer/class/getClassRoomSummary`, params);
}

/**
 * 课堂回放-植入记忆
 * @param {*} params
 * @returns
 */
export async function insertMemory(params) {
  return $x.post(`/ptrainer/class/insertMemory`, params);
}

/**
 * 课堂回放-处理待办
 * @param {*} params
 * @returns
 */
export async function handleTodo(params) {
  return $x.post(`/ptrainer/class/handleTodo`, params);
}

export async function addEquipment(params) {
  return $x.post(`/equipment/add`, params);
}

export async function modifyEquipment(params) {
  return $x.post(`/equipment/modify`, params);
}

export async function operateEquipment(params) {
  return $x.post(`/equipment/operate`, params);
}

export async function getEquipmentList(params) {
  return $x.post(`/equipment/list`, params);
}

export async function getEquipmentDetail(params) {
  return $x.post(`/equipment/detail`, params);
}

export async function getEquipmentRelatedActionList(params) {
  return $x.post(`/equipment/relatedAction`, params);
}

export async function listStoreEquipment(params) {
  return $x.post(`/equipment/listStoreEquipment`, params);
}

export async function addStoreEquipment(params) {
  return $x.post(`/equipment/addStoreEquipment`, params);
}
